/* eslint-disable func-names */
import $ from "jquery";
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/bundle';
import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';



const swiperVoice = () => {
    const swiperContainer = document.querySelector(".js-voice-swiper");

    if (!swiperContainer) {
        console.warn("Voice swiper container not found");
        return;
    }

    const swiper = new Swiper(".js-voice-swiper", {
        modules: [Navigation, Pagination],
        speed: 1000,
        slidesPerView: 2.8,
        spaceBetween: 20,
        freeMode: true,
        navigation: {
            nextEl: ".js-voice-swiper .swiper-button-next",
            prevEl: ".js-voice-swiper .swiper-button-prev",
        },
        pagination: {
            el: '.js-voice-swiper .swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            640: {
                slidesPerView: 3,
                spaceBetween: 20,
                freeMode: false,
            }
        }
    });
}

const scrollbar = () => {
    const scrollElements = document.querySelectorAll('.js-scrollbar');
    scrollElements.forEach((element) => {
        new SimpleBar(element);
    });
};

const accordion = () => {
    $('.js-accordion').on('click', function () {
        const $this = $(this);
        const $content = $this.next();

        $content.slideToggle();

        // data-open属性の付与・削除
        if ($this.attr('data-open') !== undefined) {
            $this.removeAttr('data-open');
            $content.removeAttr('data-open');
        } else {
            $this.attr('data-open', '');
            $content.attr('data-open', '');
        }
    });
};

const main = () => {
    if (document.querySelector('#page-fp-consultation') === null) return;
    swiperVoice();
    scrollbar();
    accordion();
}

export default main;
